"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllSupportedLanguages = exports.getDemoAddressByKey = exports.getDemoAddresses = exports.getTimezoneByKey = exports.getAllTimezones = exports.getLocaleByKey = exports.getAllLocales = exports.getCurrencyByKey = exports.getAllCurrencies = exports.getStateByKey = exports.getCountryByShortKey = exports.getCountryByKey = exports.getAllCountries = void 0;
var address_format_1 = require("./address-format");
var datasetData = require("@wix/locale-dataset-data");
var constants_1 = require("./constants");
var dataset = datasetData;
// Helpers
var clone = function (item) { return JSON.parse(JSON.stringify(item)); };
var all = function (arr) { return clone(arr); };
var byKey = function (arr, key) {
    var item = arr.filter(function (arrItem) { return arrItem.key === key; })[0];
    return item ? clone(item) : null;
};
var byShortKey = function (arr, shortKey) {
    var item = arr.filter(function (arrItem) { return arrItem.shortKey === shortKey; })[0];
    return item ? clone(item) : null;
};
// Public API
exports.getAllCountries = function (opts) {
    if (opts === void 0) { opts = {}; }
    return all(dataset.countries).filter(function (country) {
        return !opts.filterForbiddenCountries ||
            !constants_1.FORBIDDEN_COUNTRY_CODES.includes(country.key);
    });
};
exports.getCountryByKey = function (countryKey) {
    return byKey(dataset.countries, countryKey);
};
exports.getCountryByShortKey = function (countryShortKey) {
    return byShortKey(dataset.countries, countryShortKey);
};
exports.getStateByKey = function (countryKey, stateKey) {
    var country = byKey(dataset.countries, countryKey);
    return country && country.subdivisions
        ? byKey(country.subdivisions.list, stateKey)
        : null;
};
exports.getAllCurrencies = function () { return all(dataset.currencies); };
exports.getCurrencyByKey = function (currencyKey) {
    return byKey(dataset.currencies, currencyKey);
};
exports.getAllLocales = function () { return all(dataset.locales); };
exports.getLocaleByKey = function (localeKey) {
    return byKey(dataset.locales, localeKey.toLowerCase());
};
exports.getAllTimezones = function () { return all(dataset.timezones); };
exports.getTimezoneByKey = function (timezoneKey) {
    return byKey(dataset.timezones, timezoneKey);
};
exports.getDemoAddresses = function () { return all(dataset.demoAddresses); };
exports.getDemoAddressByKey = function (demoAddressKey) {
    return byKey(dataset.demoAddresses, demoAddressKey);
};
exports.getAllSupportedLanguages = function () {
    return all(dataset.supportedLanguages);
};
exports.default = {
    getAllCountries: exports.getAllCountries,
    getCountryByKey: exports.getCountryByKey,
    getCountryByShortKey: exports.getCountryByShortKey,
    getStateByKey: exports.getStateByKey,
    getAllCurrencies: exports.getAllCurrencies,
    getCurrencyByKey: exports.getCurrencyByKey,
    getAllLocales: exports.getAllLocales,
    getLocaleByKey: exports.getLocaleByKey,
    getAllTimezones: exports.getAllTimezones,
    getTimezoneByKey: exports.getTimezoneByKey,
    getFormattedAddress: address_format_1.getFormattedAddress,
    getDemoAddresses: exports.getDemoAddresses,
    getDemoAddressByKey: exports.getDemoAddressByKey,
    getAllSupportedLanguages: exports.getAllSupportedLanguages,
};
//# sourceMappingURL=index.js.map